import { ckAPIMethods } from 'chat-kit'
const moduleConfig = {
  info: {
    uuid: '6944d0b0-ca59-4007-97bf-867d6c4385a9'

  },
  api: {
	infApiUrl: 'http://localhost:8080/api'
  },
  uiEvents: {
    sendMessage: ckAPIMethods.recieveMessage,
    uiManagment: ckAPIMethods.uiManagment,
    notifications: ckAPIMethods.notifications,
  },
}
export default moduleConfig
